import {
    NumericRegionCode,
    RegionCode,
} from '@aviv-estimation-funnel/estimation-data-models/enums';

export const getPhoneNumberRegionCodeValues = (portalRegionCodes: RegionCode[]) => {
    return portalRegionCodes.map((regionCode) => {
        return {
            value: regionCode,
            label: `+${NumericRegionCode[regionCode]} ${regionCode}`,
            shortLabel: `+${NumericRegionCode[regionCode]}`,
        };
    });
};

export const getNumericRegionCodeValue = (regionCode: RegionCode): string | undefined => {
    const regionCodeValue = NumericRegionCode[regionCode];
    if (regionCodeValue === undefined) {
        return undefined;
    }
    return `+${NumericRegionCode[regionCode]}`;
};
